module.exports = __webpack_public_path__ + "static/media/IMG_1323.fa05b9de.jpg";